import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ProductsService } from '../../products/products/products.service';
import {
  UsersService,
  UserExtraInfoModel,
} from '../../settings/users/users.service';
import { CreatelicenseService } from './createlicense.service';
import { LicensedurationsService } from '../../settings/licensedurations/licensedurations.service';
import { ToastService } from '../../../toast.service';
import { BaseService } from '../../../base.service';
import { TestingToolkitService } from '../../../services/testing-toolkit.service';
import { threadId } from 'worker_threads';
import { Subscription } from 'rxjs';
import { freeSet } from '@coreui/icons';

interface PlanFeatureView {
  id: number;
  featureId: number;
  featureName: string;
  moduleName: string;
  isServiceItem: boolean;
  price: number;
  priceExtraStore: number;
  priceOneTime: number;
  dependencyId: number;
  transactionLimit: number;
}

interface PlanViewModel {
  id: number;
  planName: string;
  isActive: boolean;
  details: PlanFeatureView[];
  isDemo?: boolean;
  transactionTitle?: string;
}
@Component({
  selector: 'app-createlicense',

  templateUrl: './createlicense.component.html',
  styleUrl: './createlicense.component.scss',
})
export class CreatelicenseComponent {
  tooltipText = 'You can use max 10 transections per month for free.';

  roleData: any;
  usersData: any;
  taskList: any = '';
  selectedRoleId: any;
  msg: any;
  Product_Id: any;
  isBillToClient: boolean = true;
  ProductsData: any;
  D_Year: string;
  D_Month: string;
  D_Day: string;
  D_Date: any;
  E_Date: any;
  ButtonLoading: boolean = false;
  ButtonLoadingStandard: boolean = false; // For Standard Plan
  ButtonLoadingExtended: boolean = false; // For Extended Plan
  isLoading: boolean = true; // Loader flag

  productPlans: PlanViewModel[] = [];
  planButtonLoading: Record<number, boolean> = {};
  activePlanInProgressId: number | null = null;
  planLoading: boolean = false;
  plansError: string | null = null;
  selectedPlanId: number | null = null;

  licenseSubscription: Subscription | undefined;

  // Current package status properties
  currentPackageType: 'demo' | 'standard' | 'extended' | 'none' = 'none';
  currentLicenseData: any = null;
  hasActiveLicense: boolean = false;
  licensedFeatureNames: Set<string> = new Set();
  currentPlanName: string = '';

  // Pay Now Modal properties
  visiblePayNowModal: boolean = false;
  payNowForm!: FormGroup;
  PayNowButtonLoading: boolean = false;
  EditBillingAddressOnCard: boolean = false;

  constructor(
    public ProductService: ProductsService,
    public UsersService: UsersService,
    public LicensedurationsService: LicensedurationsService,
    public ClientlicensesService: CreatelicenseService,
    private router: Router,
    private ToastService: ToastService,
    private baseService: BaseService,
    public route: ActivatedRoute,
    private testingToolkit: TestingToolkitService,
    private fb: FormBuilder
  ) {
    // Use testing toolkit date if set, otherwise use current date
    const today = this.testingToolkit.getCurrentDate();
    this.D_Year = today.toLocaleDateString('en-US', { year: 'numeric' });
    this.D_Month = today.toLocaleDateString('en-US', { month: '2-digit' });
    this.D_Day = today.toLocaleDateString('en-US', { day: '2-digit' });
    this.D_Date =
      this.D_Year + '-' + this.D_Month + '-' + this.D_Day + 'T00:00:00.000Z';

    // const E_Date = new Date(this.D_Date);
    // E_Date.setMonth(E_Date.getMonth() + );
    // this.E_Date = E_Date.toLocaleDateString('en-US', { year: 'numeric' })+"-"+E_Date.toLocaleDateString('en-US', { month: '2-digit' })+"-"+E_Date.toLocaleDateString('en-US', { day: '2-digit'  })+"T23:59:59.000Z";
  }

  // toggleChildren(parentTask: TaskAssignedToRole) {
  //   const children = this.taskList.filter((task: { ParentMenuID: number; }) => task.ParentMenuID === parentTask.Id);
  //   const parentIsAllowed = parentTask.IS_ALLOWED;

  //   // Update IsActive property for the parent and its children
  //   parentTask.IS_ALLOWED = parentIsAllowed;
  //   children.forEach((child: { IS_ALLOWED: boolean; }) => child.IS_ALLOWED = parentIsAllowed);
  // }

  partnerpercentage: any = 0;
  serviceItemDiscount: any = 0;
  UserType = 6;
  Loading: boolean = false;
  UsersData: any;
  async GetUserData() {
    this.Loading = true;

    var body = {
      partner_Id: JSON.parse(
        localStorage.getItem('UserInfo')?.toString() || '{}'
      )?.partner_Id,
      userType_Id: this.UserType,
    };
    this.UsersService.getAllByUserTypeAndPartnerID(body).subscribe({
      next: (res: any) => {
        this.UsersData = res.data;
        // console.log('UsersData');
        // console.log(this.UsersData);
        this.Loading = false;
      },
      error: (error) => {
        console.error(error);
        this.Loading = false;
      },
    });
  }

  async GetProductList(cid: any) {
    this.isLoading = true; // Start loader
    if (this.totalPrice != 0) {
      this.totalPrice = 0;
    }
    this.clientID = cid;

    // --- Fetch license data for this client and auto-populate fields ---
    this.populateCentralAndExtraStoreFromLicense(cid);

    this.ProductService.getProducts().subscribe((response: any) => {

      console.log("🚀  > GetProductList > response:", response);

      this.ProductsData = response.data.filter(
        (product: any) => product.isActive == true
      );
      if (this.selectedProductId) {
        this.GetFeatureList(this.selectedProductId, true); // Pass loader flag
      } else {
        this.GetFeatureList(0, true);
      }
      this.taskList = '';
      // console.log('ProductList');
      // console.log(this.ProductsData);
    });
  }

  // --- New method to fetch and set isextraStore and extraNOS ---
  populateCentralAndExtraStoreFromLicense(clientId: any) {
    console.log(
      '🚀🚀🚀🚀🚀🚀🚀🚀🚀🚀🚀 > populateCentralAndExtraStoreFromLicense > clientId:',
      clientId
    );

    // Unsubscribe previous if any
    if (this.licenseSubscription) {
      this.licenseSubscription.unsubscribe();
    }
    // Use getAllLicensesByPersonID API instead of getAllLicensesByUserID
    const body = {
      id: clientId,
      type: 'U',
    };
    this.licenseSubscription = this.UsersService.getAllLicensesByPersonID(
      body
    ).subscribe({
      next: (res: any) => {
        console.log(
          '🚀 > this.licenseSubscription=this.UsersService.getAllLicensesByPersonID > res:',
          res
        );

        if (res.data && res.data.length > 0) {
          const firstLicense = res.data[res.data.length - 1];
          this.currentLicenseData = firstLicense;
          this.hasActiveLicense = true;

          // Set the fields if present
          if (
            firstLicense.license_Products[
            firstLicense.license_Products.length - 1
            ]
          ) {
            this.isextraStore =
              firstLicense.license_Products[
                firstLicense.license_Products.length - 1
              ].isRMHCentral;
            this.IsRMH = firstLicense.license_Products[
              firstLicense.license_Products.length - 1
            ].o_isRMS;
          }
          if (typeof firstLicense.extraStores !== 'undefined') {
            this.extraNOS = Number(firstLicense.license_Products[
              firstLicense.license_Products.length - 1
            ].extraStores) || 0;
          }

          // Determine current package type
          this.determineCurrentPackageType(firstLicense);

          // Optionally, recalculate price if needed
          this.calculateTotalPrice();
        } else {
          this.hasActiveLicense = false;
          this.currentPackageType = 'none';
          this.currentLicenseData = null;
          this.currentPlanName = '';
        }
      },
      error: (error) => {
        console.error('Failed to fetch license data for client:', error);
        this.hasActiveLicense = false;
        this.currentPackageType = 'none';
        this.currentLicenseData = null;
        this.currentPlanName = '';
      },
    });
  }

  /**
   * Determines the current package type based on license data
   */
  determineCurrentPackageType(licenseData: any) {
    if (
      !licenseData ||
      !licenseData.license_Products ||
      licenseData.license_Products.length === 0
    ) {
      this.currentPackageType = 'none';
      return;
    }

    const licenseProduct =
      licenseData.license_Products[licenseData.license_Products.length - 1];
    const licenseFeatures = licenseProduct.license_Features || [];

    // Check if it's a trial license (Demo Plan)
    if (licenseProduct.isTrial) {
      this.currentPackageType = 'demo';
      console.log('🚀 Current package type determined: DEMO (isTrial = true)');
      return;
    }

    // Get all features that are available (not closed and exist in license)
    const availableFeatures = licenseFeatures.filter(
      (feature: any) => !feature.isClosed
    );

    console.log('🚀 Available license features:', availableFeatures);

    if (availableFeatures.length === 0) {
      this.currentPackageType = 'none';
      console.log(
        '🚀 Current package type determined: NONE (no available features)'
      );
      return;
    }

    // Store features for later use in refineCurrentPackageType
    this.licensedFeatureNames = new Set(
      availableFeatures.map((feature: any) => feature.featureName)
    );

    // Initial determination - will be refined after task list is loaded
    if (availableFeatures.length === 1) {
      this.currentPackageType = 'standard';
      console.log(
        '🚀 Current package type determined: STANDARD (single feature - initial)'
      );
    } else if (availableFeatures.length > 1) {
      this.currentPackageType = 'extended';
      console.log(
        '🚀 Current package type determined: EXTENDED (multiple features - initial)'
      );
    } else {
      this.currentPackageType = 'standard';
      console.log('🚀 Current package type determined: STANDARD (fallback)');
    }
  }

  /**
   * Re-evaluates the current package type after task list is loaded
   * This provides more accurate detection using dependency information
   */
  refineCurrentPackageType() {
    if (
      !this.currentLicenseData ||
      !this.taskList ||
      this.currentPackageType === 'demo'
    ) {
      return; // Don't change demo status or if no data
    }

    const licenseFeatures =
      this.currentLicenseData.license_Products?.[
        this.currentLicenseData.license_Products.length - 1
      ]?.license_Features || [];
    const licensedFeatureNames = new Set(
      licenseFeatures
        .filter((lf: any) => !lf.isClosed)
        .map((lf: any) => lf.featureName)
    );

    let baseFeatureCount = 0;
    let dependentFeatureCount = 0;

    console.log(
      '🚀 Refining package type with licensed features:',
      Array.from(licensedFeatureNames)
    );

    // Count base features (dependencyID === 0) and dependent features
    for (const module of this.taskList) {
      if (module.featureList && Array.isArray(module.featureList)) {
        for (const feature of module.featureList) {
          if (licensedFeatureNames.has(feature.featureName)) {
            if (feature.dependencyID === 0) {
              baseFeatureCount++;
              console.log(`🚀 Base feature found: ${feature.featureName}`);
            } else {
              dependentFeatureCount++;
              console.log(
                `🚀 Dependent feature found: ${feature.featureName} (depends on ID: ${feature.dependencyID})`
              );
            }
          }
        }
      }
    }

    console.log(
      '🚀 Refined analysis - Base features:',
      baseFeatureCount,
      'Dependent features:',
      dependentFeatureCount
    );

    // Logic:
    // - Standard: has base features but no dependent features OR only one feature total
    // - Extended: has both base features and dependent features OR multiple base features
    if (baseFeatureCount === 1 && dependentFeatureCount === 0) {
      this.currentPackageType = 'standard';
      console.log(
        '🚀 Refined package type: STANDARD (single base feature, no dependents)'
      );
    } else if (baseFeatureCount > 0 && dependentFeatureCount > 0) {
      this.currentPackageType = 'extended';
      console.log(
        '🚀 Refined package type: EXTENDED (base + dependent features)'
      );
    } else if (baseFeatureCount > 1 && dependentFeatureCount === 0) {
      this.currentPackageType = 'extended';
      console.log('🚀 Refined package type: EXTENDED (multiple base features)');
    } else if (baseFeatureCount === 0 && dependentFeatureCount > 0) {
      // This shouldn't happen in normal cases, but if it does, assume extended
      this.currentPackageType = 'extended';
      console.log(
        '🚀 Refined package type: EXTENDED (dependent only - unusual case)'
      );
    } else {
      // Fallback to standard for any other case
      this.currentPackageType = 'standard';
      console.log('🚀 Refined package type: STANDARD (fallback)');
    }
  }

  /**
   * Helper method to check if a feature is a base feature (has no dependency)
   * This logic can be enhanced based on your feature dependency structure
   */
  private isBaseFeature(featureName: string): boolean {
    // This is a simple check - you might need to enhance this logic
    // based on your actual feature dependency structure
    const baseFeatureNames = ['Sales', 'Purchase', 'Inventory']; // Add more as needed
    return baseFeatureNames.includes(featureName);
  }

  /**
   * Checks if current package matches the given type
   */
  isCurrentPackage(packageType: 'demo' | 'standard' | 'extended'): boolean {
    return this.hasActiveLicense && this.currentPackageType === packageType;
  }

  /**
   * Gets the current package display name
   */
  getCurrentPackageDisplayName(): string {
    if (this.currentPlanName) {
      return this.currentPlanName;
    }
    switch (this.currentPackageType) {
      case 'demo':
        return 'Demo Plan';
      case 'standard':
        return 'Standard Plan';
      case 'extended':
        return 'Extended Plan';
      default:
        return 'No Active Plan';
    }
  }

  /**
   * Gets the current licensed features as a display array
   */
  getCurrentLicensedFeatures(): string[] {
    if (
      !this.currentLicenseData ||
      !this.currentLicenseData.license_Products ||
      this.currentLicenseData.license_Products.length === 0
    ) {
      return [];
    }

    const licenseFeatures =
      this.currentLicenseData.license_Products[
        this.currentLicenseData.license_Products.length - 1
      ].license_Features || [];

    return licenseFeatures
      .filter((feature: any) => !feature.isClosed)
      .map((feature: any) => feature.featureName);
  }

  /**
   * Gets a summary of the current package for display
   */
  getCurrentPackageSummary(): {
    packageType: string;
    features: string[];
    isExtraStoreEnabled: boolean;
    extraStoreCount: number;
    isTrial: boolean;
  } {
    return {
      packageType: this.getCurrentPackageDisplayName(),
      features: this.getCurrentLicensedFeatures(),
      isExtraStoreEnabled: this.isextraStore || false,
      extraStoreCount: this.extraNOS || 0,
      isTrial: this.currentPackageType === 'demo',
    };
  }

  /**
   * Checks if controls should be disabled when user lands on the page
   * Controls are disabled if user has an active non-trial license
   */
  shouldDisableControls(): boolean {
    // Disable controls if user has an active non-trial/non-demo license
    return this.hasActiveLicense && 
           this.currentPackageType !== 'demo' && 
           this.currentPackageType !== 'none';
  }

  /**
   * Gets the reason why controls are disabled
   */
  getDisabledReason(): string {
    if (this.shouldDisableControls()) {
      return `You already have an active ${this.getCurrentPackageDisplayName()}. For upgrades and downgrades, please visit the Subscriptions page.`;
    }
    return '';
  }

  /**
   * Checks if a specific feature is currently licensed
   */
  isFeatureLicensed(featureName: string): boolean {
    const licensedFeatures = this.getCurrentLicensedFeatures();
    return licensedFeatures.includes(featureName);
  }

  /**
   * Gets the current package status for display components
   */
  getCurrentPackageStatus(): {
    hasLicense: boolean;
    packageType: 'demo' | 'standard' | 'extended' | 'none';
    displayName: string;
    features: string[];
    isTrialExpired?: boolean;
    expiryDate?: string;
  } {
    const summary = this.getCurrentPackageSummary();
    let expiryDate = '';
    let isTrialExpired = false;

    if (this.currentLicenseData?.license_Products?.[0]) {
      const licenseProduct =
        this.currentLicenseData.license_Products[
        this.currentLicenseData.license_Products.length - 1
        ];
      expiryDate = licenseProduct.date_Expire;

      if (licenseProduct.isTrial) {
        const expiry = new Date(licenseProduct.date_Expire);
        isTrialExpired = expiry < new Date();
      }
    }

    return {
      hasLicense: this.hasActiveLicense,
      packageType: this.currentPackageType,
      displayName: summary.packageType,
      features: summary.features,
      isTrialExpired,
      expiryDate,
    };
  }

  /**
   * Gets CSS class for current package badge/button styling
   */
  getCurrentPackageBadgeClass(): string {
    switch (this.currentPackageType) {
      case 'demo':
        return 'badge badge-warning';
      case 'standard':
        return 'badge badge-info';
      case 'extended':
        return 'badge badge-success';
      default:
        return 'badge badge-secondary';
    }
  }

  /**
   * Gets current package icon class
   */
  getCurrentPackageIcon(): string {
    switch (this.currentPackageType) {
      case 'demo':
        return 'fa fa-clock';
      case 'standard':
        return 'fa fa-star';
      case 'extended':
        return 'fa fa-star-o';
      default:
        return 'fa fa-times';
    }
  }

  /**
   * Shows formatted current package information for display
   */
  getCurrentPackageDisplayInfo(): string {
    if (!this.hasActiveLicense) {
      return 'No Active License';
    }

    const status = this.getCurrentPackageStatus();
    const featureCount = status.features.length;

    let info = `${status.displayName}`;
    if (featureCount > 0) {
      info += ` (${featureCount} feature${featureCount > 1 ? 's' : ''})`;
    }

    if (status.isTrialExpired) {
      info += ' - EXPIRED';
    } else if (this.currentPackageType === 'demo') {
      info += ' - Trial';
    }

    return info;
  }

  /**
   * Pre-selects features in the task list based on current license
   */
  preselectFeaturesFromLicense() {
    if (!this.currentLicenseData || !this.taskList) {
      console.log(
        '🚀 Cannot preselect features: missing license data or task list'
      );
      return;
    }

    const licenseFeatures =
      this.currentLicenseData.license_Products?.[
        this.currentLicenseData.license_Products.length - 1
      ]?.license_Features || [];

    // Create a map of licensed feature names for quick lookup (only non-closed features)
    const licensedFeatureNames = new Set(
      licenseFeatures
        .filter((lf: any) => !lf.isClosed)
        .map((lf: any) => lf.featureName)
    );

    console.log(
      '🚀 Licensed features to preselect:',
      Array.from(licensedFeatureNames)
    );

    // Pre-select features that match the current license
    for (const module of this.taskList) {
      if (module.featureList && Array.isArray(module.featureList)) {
        for (const feature of module.featureList) {
          // Select feature if it exists in current license
          if (licensedFeatureNames.has(feature.featureName)) {
            feature.selected = true;
            console.log(`🚀 Pre-selected feature: ${feature.featureName}`);
          } else {
            // Ensure other features are not selected by default
            feature.selected = false;
          }
        }
      }
    }

    // Recalculate total price after pre-selection
    this.calculateTotalPrice();

    console.log('🚀 Features preselected and price recalculated');
  }

  proId: any;
  IsAllowedCentral: boolean = false;
  DurationOption: any;
  IsProductSelected: boolean = false;
  async GetFeatureList(ProId: any, shouldStopLoader: boolean = false) {
    this.durationoptionselected = false;
    if (this.totalPrice != 0) {
      this.totalPrice = 0;
    }
    if (ProId != 0) {
      this.IsProductSelected = true;
      this.selectedProductId = ProId;
    } else {
      this.IsProductSelected = false;
    }
    this.LicensedurationsService.getAssignedLicensedurationsByProductId(
      ProId
    ).subscribe((response: any) => {
      this.DurationOption = response.data;

      console.log(
        '🚀 > ).subscribe > this.DurationOption:',
        this.DurationOption
      );

      // Auto-select duration based on previous license or first active duration
      if (this.DurationOption && this.DurationOption.length > 0) {
        let durationToSelect = null;
        console.log(this.hasActiveLicense, this.currentLicenseData);
        // Check if there's a previous license with duration info
        if (this.hasActiveLicense && this.currentLicenseData.license_Products[
          this.currentLicenseData.license_Products.length - 1
        ].isTrial == false && this.currentLicenseData?.license_Products?.length > 0) {
          const lastLicenseProduct = this.currentLicenseData.license_Products[
            this.currentLicenseData.license_Products.length - 1
          ];
          
          // Check for plD_Duration and plD_ChargeDuration
          const previousDuration = lastLicenseProduct.plD_Duration;
          const previousChargeDuration = lastLicenseProduct.plD_ChargeDuration;

          console.log(
            '🚀 Previous license duration info:',
            { previousDuration, previousChargeDuration }
          );

          // Find matching duration based on duration and chargeDuration
          if (previousDuration && previousChargeDuration) {
            durationToSelect = this.DurationOption.find(
              (d: any) =>
                Number(d.duration) === Number(previousDuration) &&
                Number(d.chargeDuration) === Number(previousChargeDuration)
            );

            if (durationToSelect) {
              console.log(
                '🚀 Matched duration from previous license:',
                durationToSelect
              );
            }
          }
        }

        // Fallback to first active duration if no match found
        if (!durationToSelect) {
          durationToSelect = this.DurationOption.find((d: any) => d.isActive);
        }

        if (durationToSelect) {
          this.selectedDuration = durationToSelect;
          this.durationcheck(durationToSelect.id);
        }
      }

      if (shouldStopLoader) {
        this.isLoading = false; // Stop loader after durations are loaded
      }

      console.log(this.DurationOption);
    });

    const pdata = this.ProductsData.find((product: { id: any }) => {
      return product.id == ProId;
    });

    if (pdata) {
      // console.log(pdata.isCentralAllowed);
      this.IsAllowedCentral = pdata.isCentralAllowed;
    } else {
      // console.log('Product with ID', ProId, 'not found.');
    }

    this.proId = ProId;

    if (ProId && ProId !== 0) {
      this.fetchPlansForProduct(ProId);
    } else {
      this.productPlans = [];
      this.planButtonLoading = {};
      this.selectedPlanId = null;
    }

    this.ClientlicensesService.getTaskList(ProId).subscribe((response: any) => {
      this.taskList = response.data;

      console.log('🚀 Task list loaded:', this.taskList);

      // Pre-select features based on current license
      this.preselectFeaturesFromLicense();

      // Refine package type determination with dependency information
      this.refineCurrentPackageType();

      console.log(
        '🚀 Final package type after refinement:',
        this.currentPackageType
      );

      // console.log('===list====');
      // console.log(this.taskList);

      this.selectedRoleId = ProId;
    });
  }

  private mapPlanDetails(planDetail: any[]): PlanFeatureView[] {
    if (!Array.isArray(planDetail)) {
      return [];
    }

    return planDetail
      .map((detail: any) => {
        const feature = detail?.productFeaturess || {};
        const moduleInfo = detail?.productModules || {};

        const featureId = Number(feature?.id ?? detail?.productFeatures_Id);
        if (!featureId) {
          return null;
        }

        return {
          id: Number(detail?.id ?? featureId),
          featureId,
          featureName: feature?.featureName || 'Unnamed Feature',
          moduleName: moduleInfo?.moduleName || 'General',
          isServiceItem: Boolean(feature?.isServiceItem),
          price: Number(feature?.price || 0),
          priceExtraStore: Number(feature?.price_ExtraStore || 0),
          priceOneTime: Number(feature?.price_OneTime || 0),
          dependencyId: Number(feature?.dependencyID || 0),
          transactionLimit: Number(detail?.transactionLimit || 0),
        } as PlanFeatureView;
      })
      .filter((detail): detail is PlanFeatureView => detail !== null);
  }

  private mapPlanResponse(plan: any): PlanViewModel | null {
    if (!plan) {
      return null;
    }

    const details = this.mapPlanDetails(plan?.planDetail || []);

    return {
      id: Number(plan?.id || 0),
      planName: plan?.planName || 'Plan',
      isActive: Boolean(plan?.isActive),
      details,
      isDemo: Boolean(plan?.isDemo || false),
      transactionTitle: plan?.transactionTitle || '',
    };
  }

  fetchPlansForProduct(productId: number): void {
    this.planLoading = true;
    this.plansError = null;

    this.ClientlicensesService.getPlansByProductId(productId).subscribe({
      next: (response: any) => {
        const plans = Array.isArray(response?.data) ? response.data : [];

        this.productPlans = plans
          .map((plan: any) => this.mapPlanResponse(plan))
          .filter(
            (plan: PlanViewModel | null): plan is PlanViewModel =>
              !!plan && plan.details.length > 0
          )
          .sort((a: PlanViewModel, b: PlanViewModel) => {
            if (a.isDemo && !b.isDemo) return -1;
            if (!a.isDemo && b.isDemo) return 1;
            // Calculate total price for each plan
            const totalPriceA = a.details.reduce((sum: number, detail: PlanFeatureView) => sum + detail.price, 0);
            const totalPriceB = b.details.reduce((sum: number, detail: PlanFeatureView) => sum + detail.price, 0);
            return totalPriceA - totalPriceB; // Ascending order
          });

        this.activePlanInProgressId = null;
        this.planButtonLoading = {};

        // Auto-select current plan if user has active license
        if (this.hasActiveLicense && this.currentLicenseData?.license_Products?.length > 0) {
          const lastLicenseProduct = this.currentLicenseData.license_Products[
            this.currentLicenseData.license_Products.length - 1
          ];

          if (lastLicenseProduct && lastLicenseProduct.planMaster_Id) {
            const matchingPlan = this.productPlans.find(
              (p) => p.id === lastLicenseProduct.planMaster_Id
            );

            if (matchingPlan) {
              this.selectedPlanId = matchingPlan.id;
              this.currentPlanName = matchingPlan.planName;
              console.log(
                '🚀 Auto-selected current plan:',
                { id: this.selectedPlanId, name: this.currentPlanName }
              );
            } else {
              console.log(
                '⚠️ Current plan not found in available plans:',
                lastLicenseProduct.planMaster_Id
              );
            }
          }
        }

        if (!this.productPlans.find((plan) => plan.id === this.selectedPlanId)) {
          if (!this.hasActiveLicense || this.currentPackageType === 'demo') {
            this.selectedPlanId = null;
          }
        }

        // Set current plan name if license has a plan (fallback)
        if (!this.currentPlanName && this.currentLicenseData?.license_Products?.length > 0) {
          const CurrentLisence = this.currentLicenseData.license_Products[
            this.currentLicenseData.license_Products.length - 1
          ];

          if (CurrentLisence && CurrentLisence.planMaster_Id) {
            const currentPlan = this.productPlans.find(
              (p) => p.id === CurrentLisence.planMaster_Id
            );
            if (currentPlan) {
              this.currentPlanName = currentPlan.planName;
              console.log('🚀 Set current plan name:', this.currentPlanName);
            }
          }
        }
      },
      error: (error) => {
        console.error('Failed to fetch plans by product ID:', error);
        this.productPlans = [];
        this.plansError = 'Unable to load plans for the selected product.';
        this.planLoading = false;
      },
      complete: () => {
        this.planLoading = false;
      },
    });
  }

  getPlanTotal(plan: PlanViewModel): number {
    if (!plan) {
      return 0;
    }

    if (this.selectedDuration?.isTrial) {
      return 0;
    }

    const durationMultiplier = Number(
      this.selectedDuration?.chargeDuration || 1
    );

    let total = 0;

    for (const detail of plan.details) {
      if (detail.isServiceItem) {
        continue;
      }
      total += detail.price * durationMultiplier;
      total += detail.priceOneTime || 0;
    }

    return total;
  }

  getPlanRealTotal(plan: PlanViewModel): number {
    if (!plan) {
      return 0;
    }

    if (!this.selectedDuration || this.selectedDuration === 0) {
      return this.getPlanTotal(plan);
    }

    const durationMultiplier = Number(this.selectedDuration?.duration || 1);
    let total = 0;

    for (const detail of plan.details) {
      if (detail.isServiceItem) {
        continue;
      }
      total += detail.price * durationMultiplier;
      total += detail.priceOneTime || 0;
    }

    return total;
  }

  getPlanAdditionalStorePrice(plan: PlanViewModel): number {
    if (
      !plan ||
      !this.selectedDuration ||
      !this.extraNOS ||
      this.extraNOS <= 0 ||
      !this.IsAllowedCentral
    ) {
      return 0;
    }

    const durationMultiplier = Number(
      this.selectedDuration?.chargeDuration || 1
    );

    let total = 0;

    for (const detail of plan.details) {
      if (detail.isServiceItem) {
        continue;
      }
      total += detail.priceExtraStore * this.extraNOS * durationMultiplier;
    }

    return total;
  }

  async choosePlan(plan: PlanViewModel): Promise<void> {
    if (!plan) {
      return;
    }

    if (!this.taskList || !Array.isArray(this.taskList)) {
      console.warn('Task list not loaded. Unable to apply plan.');
      return;
    }

    // Check if business info is required before proceeding
    const hasBusinessInfo = await this.checkIfBusinessInfoExists();
    
    if (!hasBusinessInfo) {
      // Store the plan to apply after modal submission
      this.pendingPlan = plan;
      // Show the business info modal
      this.UsersService.BusinessInfoData.emailAddress = this.UserData.userName;

      this.toggleModal();
      return; // Don't proceed until modal is closed
    }

    // Business info exists, proceed with plan selection
    this.applyPlanSelection(plan);
  }

  /**
   * Applies the plan selection and shows Pay Now modal
   */
  private applyPlanSelection(plan: PlanViewModel): void {
    // Reset any previous plan-specific loader
    if (this.activePlanInProgressId !== null) {
      this.planButtonLoading[this.activePlanInProgressId] = false;
    }

    this.planButtonLoading[plan.id] = true;
    this.activePlanInProgressId = plan.id;
    this.selectedPlanId = plan.id;

    // Clear existing selections
    for (const module of this.taskList) {
      if (module.featureList && Array.isArray(module.featureList)) {
        for (const feature of module.featureList) {
          feature.selected = false;
        }
      }
    }

    // Apply plan features
    for (const detail of plan.details) {
      this.applyPlanFeature(detail.featureId);
    }

    this.calculateTotalPrice();

    // Show Pay Now modal instead of calling updateAllTasks
    this.showPayNowModal();
  }

  private applyPlanFeature(featureId: number): void {
    for (const module of this.taskList) {
      if (module.featureList && Array.isArray(module.featureList)) {
        for (const feature of module.featureList) {
          if (Number(feature.id) === Number(featureId)) {
            feature.selected = true;
            if (feature.dependencyID) {
              this.selectDependentFeature(feature.dependencyID);
            }
            return;
          }
        }
      }
    }
  }

  private resetPlanLoadingState(): void {
    if (this.activePlanInProgressId !== null) {
      this.planButtonLoading[this.activePlanInProgressId] = false;
      this.activePlanInProgressId = null;
    }
  }

  // ============ Pay Now Modal Methods ============

  /**
   * Shows the Pay Now modal and pre-populates billing address from BusinessInfoData
   */
  showPayNowModal(): void {
    // Pre-populate billing address from BusinessInfoData
    this.payNowForm.patchValue({
      addressLine1: this.UsersService.BusinessInfoData.streetAddr || '',
      state: this.UsersService.BusinessInfoData.state || '',
      city: this.UsersService.BusinessInfoData.city || '',
      zipCode: this.UsersService.BusinessInfoData.zipCode || '',
      country: this.UsersService.BusinessInfoData.country || '',
    });

    // Reset card fields
    this.payNowForm.patchValue({
      firstName: '',
      lastName: '',
      cardNumber: '',
      expiryMonth: '',
      expiryYear: '',
      cvv: '',
    });

    // Disable billing address fields by default
    this.payNowForm.controls['addressLine1'].disable();
    this.payNowForm.controls['state'].disable();
    this.payNowForm.controls['city'].disable();
    this.payNowForm.controls['zipCode'].disable();
    this.payNowForm.controls['country'].disable();

    this.EditBillingAddressOnCard = false;
    this.visiblePayNowModal = true;
  }

  /**
   * Toggles the Pay Now modal visibility
   */
  togglePayNowModal(): void {
    if (this.visiblePayNowModal) {
      // Reset form and loading state when closing
      this.payNowForm.reset();
      this.resetPlanLoadingState();
    }
    this.visiblePayNowModal = !this.visiblePayNowModal;
  }

  /**
   * Handles billing address edit toggle in Pay Now modal
   */
  onChangeBillingAddressOnCard(event: any): void {
    if (event.target.checked) {
      this.payNowForm.controls['addressLine1'].enable();
      this.payNowForm.controls['state'].enable();
      this.payNowForm.controls['city'].enable();
      this.payNowForm.controls['zipCode'].enable();
      this.payNowForm.controls['country'].enable();
    } else {
      this.payNowForm.controls['addressLine1'].disable();
      this.payNowForm.controls['state'].disable();
      this.payNowForm.controls['city'].disable();
      this.payNowForm.controls['zipCode'].disable();
      this.payNowForm.controls['country'].disable();

      // Reset to original values from BusinessInfoData
      this.payNowForm.patchValue({
        addressLine1: this.UsersService.BusinessInfoData.streetAddr || '',
        state: this.UsersService.BusinessInfoData.state || '',
        city: this.UsersService.BusinessInfoData.city || '',
        zipCode: this.UsersService.BusinessInfoData.zipCode || '',
        country: this.UsersService.BusinessInfoData.country || '',
      });
    }
  }

  /**
   * Handles Pay Now form submission
   */
  onPayNowSubmit(): void {
    if (this.payNowForm.invalid) {
      this.payNowForm.markAllAsTouched();
      return;
    }

    this.PayNowButtonLoading = true;
    const formData = this.payNowForm.getRawValue(); // getRawValue includes disabled fields

    // Build the combined request body
    const purchaseData = this.buildPurchaseWithCardRequest(formData);

    console.log('PurchaseWithCard request data:', purchaseData);

    this.ClientlicensesService.PurchaseWithCard(purchaseData).subscribe({
      next: (response: any) => {
        console.log('PurchaseWithCard response:', response);

        if (response.apiStatus?.isSuccess) {
          this.visiblePayNowModal = false;
          this.ClearAll();

          // Navigate to subscriptions/license page on success
          this.router.navigate(['/subscriptions']).then(() => {
            setTimeout(() => {
              const options = {
                title: 'Success',
                delay: 3000,
                color: 'success',
                autohide: true,
                description: response.apiStatus.message || 'License purchased successfully',
                status: true,
              };
              this.ToastService.showToast(options);
            }, 500);
          });
        } else {
          // Show error toast but keep modal open
          const options = {
            title: 'Payment Failed',
            delay: 5000,
            color: 'danger',
            autohide: true,
            description: response.apiStatus?.message || 'Payment processing failed. Please try again.',
            status: false,
          };
          this.ToastService.showToast(options);
          this.PayNowButtonLoading = false;
        }
      },
      error: (error) => {
        console.error('PurchaseWithCard error:', error);
        const errorMessage =
          error?.error?.apiStatus?.message ||
          'Payment processing failed. Please check your card details and try again.';

        const options = {
          title: 'Payment Error',
          delay: 5000,
          color: 'danger',
          autohide: true,
          description: errorMessage,
          status: false,
        };
        this.ToastService.showToast(options);
        this.PayNowButtonLoading = false;
      },
    });
  }

  /**
   * Builds the combined PurchaseWithCard API request body
   */
  private buildPurchaseWithCardRequest(formData: any): any {
    const productFeatureList: number[] = [];

    for (const module of this.taskList) {
      for (const feature of module.featureList) {
        if (feature.selected) {
          productFeatureList.push(feature.id);
        }
      }
    }

    // Get today's date in ISO format
    const today = this.testingToolkit.getCurrentDate();
    const todayISO = today.toISOString();

    // Calculate next payment date (billing cycle end)
    const nextPaymentDate = new Date(today);
    nextPaymentDate.setMonth(
      nextPaymentDate.getMonth() + (this.selectedDuration?.chargeDuration || 1)
    );

    return {
      // Billing Details
      billingDetail: {
        companyName: this.UsersService.BusinessInfoData.legalName || '',
        addressLine1:
          formData.addressLine1 ||
          this.UsersService.BusinessInfoData.streetAddr ||
          '',
        addressLine2: '.',
        city:
          formData.city || this.UsersService.BusinessInfoData.city || '',
        state:
          formData.state || this.UsersService.BusinessInfoData.state || '',
        country:
          formData.country ||
          this.UsersService.BusinessInfoData.country ||
          '',
        zipCode:
          formData.zipCode ||
          this.UsersService.BusinessInfoData.zipCode ||
          '',
        email:
          this.UsersService.BusinessInfoData.emailAddress ||
          this.UserData.userName ||
          '',
        phone: this.UsersService.BusinessInfoData.phoneNo || '',
        nextPaymentDate: nextPaymentDate.toISOString(),
      },

      // Card Details
      cardDetail: {
        cardFirstName: formData.firstName,
        cardNumber: formData.cardNumber,
        cvv: formData.cvv,
        mm: formData.expiryMonth,
        yy: formData.expiryYear,
        cardLastName: formData.lastName,
        billingCycle: this.selectedDuration?.duration?.toString() || '1',
      },

      // License Details
      extraStores: this.extraNOS || 0,
      isBillToClient: this.isBillToClient,
      isNFR: false,
      isRMHCentral: this.isextraStore || false,
      isRMS: this.IsRMH === undefined ? false : this.IsRMH,
      isTrial: this.selectedDuration?.isTrial || false,
      owner_ID: JSON.parse(
        localStorage.getItem('UserInfo')?.toString() || '{}'
      )?.id,
      partner_ID: JSON.parse(
        localStorage.getItem('UserInfo')?.toString() || '{}'
      )?.partner_Id,
      planMaster_Id: this.selectedPlanId,
      productList: [
        {
          productID: this.proId,
          date_Start: this.D_Date,
          isProRateApply: false,
          licenseDurationID: this.selectedDuration?.id,
          featureList: productFeatureList,
        },
      ],
      user_ID: this.clientID,
      datE_CREATE: todayISO,

      // New fields per requirements
      autoRenew: true, // Default to true
      date_TrialEnd: this.selectedDuration?.isTrial ? this.E_Date : null,
      paymentDate: todayISO, // Today's date
      isDryRun: false, // Always false for real purchases
    };
  }

  // ============ End Pay Now Modal Methods ============

  CalculateDuration(numberofmonths: any): { startDate: Date; endDate: Date } {
    // Get the current UTC date
    const currentDate = new Date();

    // Calculate the end date based on the input value
    const endDate = new Date(
      currentDate.setUTCMonth(currentDate.getUTCMonth() + numberofmonths)
    );

    // Return both start and end dates

    return {
      startDate: new Date(), // current date and time
      endDate,
    };
  }
  // Returns true if the module has at least one feature with dependencyId === 0
  hasFeatureWithDependencyZero(module: any): boolean {
    return (
      module.featureList &&
      module.featureList.some((feature: any) => feature.dependencyID == 0)
    );
  }

  durationoptionselected: boolean = false;
  durationoptionTitle: string = '';
  durationcheck(m: any) {
    this.durationoptionselected = true;
    this.durationoptionTitle = this.DurationOption.find(
      (option: { id: any }) => option.id == m
    ).optionTitle;

    this.storewithduration = 0;
    const filteredOptions = this.DurationOption.filter(
      (duration: { id: any }) => {
        return duration.id == m;
      }
    );

    console.log('ok to yaha agya hai ');
    filteredOptions.forEach((option: any) => {
      console.log('ye option hai charge ki value ka ' + option.chargeDuration);
      this.selectedDuration = option;
      console.log('ye duration hai' + this.selectedDuration.duration);
    });
    //const duration = this.CalculateDuration(m);
    if (m == 0) {
      this.selectedDuration = 0;
      this.calculateTotalPrice();
    }

    const E_Date = new Date(this.D_Date);
    E_Date.setMonth(E_Date.getMonth() + this.selectedDuration.duration);
    this.E_Date =
      E_Date.toLocaleDateString('en-US', { year: 'numeric' }) +
      '-' +
      E_Date.toLocaleDateString('en-US', { month: '2-digit' }) +
      '-' +
      E_Date.toLocaleDateString('en-US', { day: '2-digit' }) +
      'T23:59:59.000Z';

    this.calculateTotalPrice();
  }

  /**
   * Gets filtered duration options - currently returns all active durations
   * Can be modified to show only specific options (e.g., Monthly/Yearly)
   */
  getFilteredDurationOptions(): any[] {
    if (!this.DurationOption) return [];
    return this.DurationOption.filter((duration: any) => duration.isActive);
  }

  /**
   * Handles duration toggle - updates selectedDuration and recalculates prices
   */
  onDurationToggle(duration: any): void {
    if (!duration) return;
    this.durationcheck(duration.id);
  }

  /**
   * Calculates the discount percentage based on the difference between 
   * the actual duration and the charged duration
   */
  getDiscountPercentage(): number {
    if (!this.selectedDuration) return 0;
    
    const actualDuration = Number(this.selectedDuration.duration) || 1;
    const chargedDuration = Number(this.selectedDuration.chargeDuration) || 1;
    
    if (actualDuration <= chargedDuration) return 0;
    
    // Calculate discount percentage
    const discountRatio = (chargedDuration / actualDuration);
    const discountPercentage = ((1 - discountRatio) * 100);
    
    return discountPercentage;
  }

  /**
   * Calculates discount percentage for a specific duration option
   * Used in the toggle button display
   */
  getDiscountPercentageForDuration(duration: any): number {
    if (!duration) return 0;
    
    const actualDuration = Number(duration.duration) || 1;
    const chargedDuration = Number(duration.chargeDuration) || 1;
    
    if (actualDuration <= chargedDuration) return 0;
    
    // Calculate discount percentage
    const discountRatio = (chargedDuration / actualDuration);
    const discountPercentage = ((1 - discountRatio) * 100);
    
    return discountPercentage;
  }

  /**
   * Calculates the absolute discount amount in currency
   */
  getDiscountAmount(): number {
    if (!this.selectedDuration || !this.productPlans || this.productPlans.length === 0) {
      return 0;
    }
    
    const actualDuration = Number(this.selectedDuration.duration) || 1;
    const chargedDuration = Number(this.selectedDuration.chargeDuration) || 1;
    
    if (actualDuration <= chargedDuration) return 0;
    
    // Calculate total price without discount (full duration)
    let totalWithoutDiscount = 0;
    for (const plan of this.productPlans) {
      totalWithoutDiscount += this.getPlanTotal(plan);
    }
    
    // Calculate the price based on actual duration vs charged duration
    const discountPercentage = this.getDiscountPercentage();
    const discountAmount = totalWithoutDiscount * (discountPercentage / 100);
    
    return discountAmount;
  }

  selectedFeatures: any[] = [];
  totalPrice: any = 0;
  extraNOS: any = 0;
  additionalStorePrice: any = 0;
  totalPriceWithAdditionalStore: any = 0;
  selectedDuration: any = 0;
  individualStorePrice: any = 0;
  serviceitemprice: any = 0;
  serviceitemonthly: any = 0;
  serviceitemadditional: any = 0;
  totaloffserviceitemadditional: any = 0;
  serviceitemadditionalwithduration: any = 0;

  serviceitemonetime: any = 0;
  totalofserviceitemonetime: any = 0;
  featureTotalPrice: any = 0;
  onetimeprice: any = 0;
  storewithduration: any = 0;
  totaloffeatureprice: any = 0;
  totalofonetimeprice: any = 0;
  totalofextrastoreprice: any = 0;
  calculateTotalPrice(): void {
    if (this.selectedDuration == 0) {
      this.totalPrice = 0;
      this.additionalStorePrice = 0;
      this.totalPriceWithAdditionalStore = 0;
      this.individualStorePrice = 0;
      this.storewithduration = 0;
      this.onetimeprice = 0;
      this.totaloffeatureprice = 0;
      this.totalofonetimeprice = 0;
      this.totalofextrastoreprice = 0;
      this.serviceitemprice = 0;
      this.serviceitemonthly = 0;
      this.serviceitemadditional = 0;
      this.totaloffserviceitemadditional = 0;
      this.serviceitemadditionalwithduration = 0;
      this.serviceitemonetime = 0;
      this.totalofserviceitemonetime = 0;

      return;
    }
    if (this.selectedDuration.isTrial == true) {
      this.totalPrice = 0;
      this.additionalStorePrice = 0;
      this.totalPriceWithAdditionalStore = 0;
      this.individualStorePrice = 0;
      this.storewithduration = 0;
      this.onetimeprice = 0;
      this.totaloffeatureprice = 0;
      this.totalofonetimeprice = 0;
      this.totalofserviceitemonetime = 0;
      this.totalofextrastoreprice = 0;
      this.serviceitemprice = 0;

      this.serviceitemonthly = 0;
      this.serviceitemadditional = 0;
      this.totaloffserviceitemadditional = 0;
      this.serviceitemadditionalwithduration = 0;

      this.serviceitemonetime = 0;

      return;
    }
    if (this.extraNOS < 0) {
      this.extraNOS = 0;
    }

    this.totalPrice = 0;
    this.additionalStorePrice = 0;
    this.totalPriceWithAdditionalStore = 0;
    this.individualStorePrice = 0;

    this.onetimeprice = 0;
    this.totaloffeatureprice = 0;
    this.totalofonetimeprice = 0;
    this.totalofserviceitemonetime = 0;
    this.totalofextrastoreprice = 0;
    this.serviceitemprice = 0;

    this.serviceitemonthly = 0;
    this.serviceitemadditional = 0;
    this.totaloffserviceitemadditional = 0;

    this.serviceitemonetime = 0;

    for (const module of this.taskList) {
      for (const feature of module.featureList) {
        if (feature.selected) {
          this.featureTotalPrice = feature.price;
          this.onetimeprice = feature.price_OneTime;

          // console.log('onetimeprice : ' + this.onetimeprice);

          this.featureTotalPrice *= this.selectedDuration.chargeDuration;

          this.totaloffeatureprice += this.featureTotalPrice;
          if (feature.isServiceItem == true) {
            // console.log('serviceitemonthly : ' + feature.price);
            this.serviceitemprice = feature.price;
            this.serviceitemprice *= this.selectedDuration.chargeDuration;
            this.serviceitemonthly += this.serviceitemprice;

            this.serviceitemonetime = feature.price_OneTime;

            this.totalofserviceitemonetime += this.serviceitemonetime;
          }

          this.totalofonetimeprice += this.onetimeprice;

          this.featureTotalPrice += this.onetimeprice;
          this.totalPrice += this.featureTotalPrice;

          // if(this.selectedDuration == 0)
          // {
          //   this.totalPrice *= 0;
          //   this.totalofonetimeprice *= 0;
          //   this.totaloffeatureprice *= 0;
          // }
          // Calculate additional store price
          if (this.extraNOS >= 0) {
            this.additionalStorePrice +=
              this.extraNOS * feature.price_ExtraStore;

            if (feature.isServiceItem == true) {
              // console.log('serviceitemadditional form inside stores : ' + feature.price_ExtraStore);
              this.serviceitemadditional +=
                this.extraNOS * feature.price_ExtraStore;
            }
          } else {
            this.extraNOS = 0;
          }

          // Calculate individual additional store price with duration
          // console.log(
          //   'before individual store price' + this.individualStorePrice
          // );
          this.individualStorePrice = this.additionalStorePrice;

          // console.log(
          //   'before totaloffserviceitemadditional store price' + this.individualStorePrice
          // );
          this.totaloffserviceitemadditional = this.serviceitemadditional;
          // if (this.selectedDuration == 6) {
          //   console.log('before multiply 5 months ==============================='+this.individualStorePrice);
          //   this.individualStorePrice *= 5; // Multiply by 5 for 6 months
          //   console.log('after multiply 5 months'+this.individualStorePrice);
          // } else if (this.selectedDuration == 12) {
          //   console.log('before multiply 10 months'+this.individualStorePrice);
          //   this.individualStorePrice *= 10; // Multiply by 5 for 6 months
          //   console.log('after multiply 10 months'+this.individualStorePrice);
          // }

          this.individualStorePrice *= this.selectedDuration.chargeDuration;
          this.totaloffserviceitemadditional *=
            this.selectedDuration.chargeDuration;

          // if(this.selectedDuration.duration == 0)
          // {
          //   this.individualStorePrice *= 0;
          // }
          // Apply individual additional store price to feature
          this.featureTotalPrice += this.individualStorePrice;
          // Log individual feature total price
          // console.log(
          //   `Feature: ${feature.FeatureName}, Individual Total Price: ${this.featureTotalPrice}`
          // );
        }
        this.storewithduration = this.individualStorePrice;
        this.serviceitemadditionalwithduration =
          this.totaloffserviceitemadditional;

        // console.log('storewithduration : ' + this.storewithduration);
        // console.log('additionalStorePrice  : ' + this.additionalStorePrice);
        // console.log('serviceitemadditionalwithduration : ' + this.serviceitemadditionalwithduration);
        // Calculate total price with additional store
        this.totalPriceWithAdditionalStore =
          this.totalPrice + this.storewithduration;
      }
    }
  }

  isextraStore: any = false;
  clientID: any;
  enablees() {
    if (this.isextraStore) {
      this.extraNOS = Math.max(1, this.extraNOS); // Set the value to 1 when the checkbox is checked
      this.calculateTotalPrice(); // Recalculate the total price
    } else {
      this.extraNOS = 0; // Set the value to zero when the checkbox is unchecked
      this.calculateTotalPrice();
    }
  }

  increaseStores() {
    this.extraNOS = (this.extraNOS || 0) + 1;
    this.isextraStore = true; // Ensure the checkbox is checked when increasing stores
    this.calculateTotalPrice();
  }

  decreaseStores() {
    if (this.extraNOS > 0) {
      this.extraNOS = this.extraNOS - 1;
      if (this.extraNOS === 0) {
        // this.isextraStore = false; // Uncheck the checkbox when stores reach 0
      }
      this.calculateTotalPrice();
    }
  }

  handleCheckboxChange(feature: any): void {
    if (feature.selected) {
      // If the feature is being selected, check for dependent features
      this.selectDependentFeature(feature.dependencyID);
    } else {
      // If the feature is being unselected, unselect its dependents
      this.deselectDependentFeature(feature.id);
    }

    // Calculate the total price regardless of dependency status
    this.calculateTotalPrice();
  }

  handleFeatureIconClick(feature: any): void {
    if (!(this.hasActiveLicense && this.currentPackageType !== 'demo')) {
      feature.selected = !feature.selected;
      this.calculateTotalPrice();
    }
  }

  selectDependentFeature(dependencyId: number): void {
    for (const module of this.taskList) {
      for (const feature of module.featureList) {
        if (feature.id === dependencyId && !feature.selected) {
          // If the feature has Id equal to the specified DependencyID and is not already selected, select it automatically
          feature.selected = true;
          // Recursively check dependencies for the newly selected feature
          this.selectDependentFeature(feature.dependencyID);
        }
      }
    }
  }

  deselectDependentFeature(parentId: number): void {
    for (const module of this.taskList) {
      for (const feature of module.featureList) {
        if (feature.dependencyID === parentId && feature.selected) {
          // If the feature has DependencyID equal to the specified parentId and is selected, unselect it
          feature.selected = false;
          // Recursively unselect dependents for the newly unselected feature
          this.deselectDependentFeature(feature.id);
        }
      }
    }
  }

  Mainmsg: any;
  Momsg: any;
  Itemmsg: any;
  Issyncmsg: any;

  // other methods and properties
  updateAllTasks() {
    // Use ButtonLoading as before for Buy Now button
    this.ButtonLoading = true;
    const productFeatureList: any[] = [];

    const requestData: {
      isOldClient: boolean;
      license_Code: any;
      date_TrialEnd: any;
      isNFR: boolean;
      extraStores: string;
      IsRMHCentral: boolean;
      IsRMS: boolean;
      PlanMaster_Id: number | null;
      isTrial: boolean;
      owner_ID: number;
      partner_ID: number;
      productList: any[];
      user_ID: any;
      isBillToClient: boolean;
    } = {
      isOldClient: false,
      license_Code: '.',
      extraStores: this.extraNOS,
      isBillToClient: this.isBillToClient,
      isNFR: false,
      isTrial: this.selectedDuration.isTrial,
      owner_ID: JSON.parse(localStorage.getItem('UserInfo')?.toString() || '{}')
        ?.id,
      partner_ID: JSON.parse(
        localStorage.getItem('UserInfo')?.toString() || '{}'
      )?.partner_Id,

      user_ID: this.clientID,
      productList: [],

      date_TrialEnd: this.D_Date,

      IsRMHCentral: this.isextraStore,
      IsRMS: this.IsRMH == undefined ? false : this.IsRMH,
      PlanMaster_Id: this.selectedPlanId,
    };

    for (const module of this.taskList) {
      for (const feature of module.featureList) {
        if (feature.selected) {
          productFeatureList.push(feature.id);
        }
      }
    }
    if (this.selectedDuration.isTrial) {
      requestData.date_TrialEnd = this.E_Date;
    }

    requestData['productList'] = [
      {
        productID: this.proId,
        date_Start: this.D_Date, // Example start date
        isProRateApply: false, // Modify as needed
        licenseDurationID: this.selectedDuration.id, // Example duration ID
        featureList: productFeatureList,
      },
    ];

    if (productFeatureList.length == 0) {
      alert('Please select atleast one feature');
      this.ButtonLoading = false;
      this.ButtonLoadingStandard = false;
      this.ButtonLoadingExtended = false;
      this.resetPlanLoadingState();

      return;
    }

    console.log('========License Data Start ===========');
    // console.log(requestData);
    console.log('========License Data End===========');

    if (requestData.productList.length > 0) {
      console.log(requestData);

      this.ClientlicensesService.InsertLicense(requestData).subscribe({
        next: (response: any) => {
          // console.log(response);
          if (response.apiStatus.isSuccess == false) {
            // const openModalButton1 = document.getElementById('openModalButtonff');
            // if (openModalButton1) {
            //   openModalButton1.click();
            // }

            this.Mainmsg = response.apiStatus.message;
            this.ClearAll();
            this.router.navigate(['/invoices']);
            setTimeout(() => {
              const options = {
                title: `License Creation Failed`,
                delay: 3000,
                color: 'danger',
                autohide: true,
                description: this.Mainmsg,
                status: false,
              };
              this.ToastService.showToast(options);
            }, 1000);
            this.ButtonLoading = false;
            this.ButtonLoadingStandard = false;
            this.ButtonLoadingExtended = false;
            this.resetPlanLoadingState();
          }

          if (response.apiStatus.isSuccess) {
            this.ClearAll();
            this.router.navigate(['/invoices']).then(() => {
              setTimeout(() => {
                const options = {
                  title: `Success`,
                  delay: 3000,
                  color: 'success',
                  autohide: true,
                  description: response.apiStatus.message,
                  status: true,
                };
                this.ToastService.showToast(options);
              }, 1000);
            });
            this.ButtonLoading = false;
            this.ButtonLoadingStandard = false;
            this.ButtonLoadingExtended = false;
            this.resetPlanLoadingState();
          }

          // this.router.navigate(['/clientpage']);
          this.msg = response.message;

          setTimeout(() => {
            this.msg = null;
          }, 5000);
          this.ngOnInit();
        },
        error: (error) => {
          console.error('Failed to create license:', error);
          const description =
            error?.error?.apiStatus?.message || 'Failed to create license.';
          setTimeout(() => {
            const options = {
              title: 'License Creation Failed',
              delay: 3000,
              color: 'danger',
              autohide: true,
              description,
              status: false,
            };
            this.ToastService.showToast(options);
          }, 300);
          this.ButtonLoading = false;
          this.ButtonLoadingStandard = false;
          this.ButtonLoadingExtended = false;
          this.resetPlanLoadingState();
        },
      });
    }
  }

  ClearAll() {
    this.IsAllowedCentral = false;
    this.taskList = '';
    this.selectedRoleId = '';
    this.extraNOS = 0;
    this.totalPrice = 0;
    this.additionalStorePrice = 0;
    this.totalPriceWithAdditionalStore = 0;
    this.selectedDuration = 0;
    this.clientID = '';
    this.isextraStore = false;
    this.individualStorePrice = 0;
    this.featureTotalPrice = 0;
    this.storewithduration = 0;
    this.Momsg = '';
    //this.Mainmsg = '';
    this.durationoptionselected = false;
    this.IsProductSelected = false;
    this.DurationOption = '';
    this.productPlans = [];
    this.planButtonLoading = {};
    this.selectedPlanId = null;
    this.activePlanInProgressId = null;
    this.planLoading = false;
    this.plansError = null;
    this.currentPlanName = '';
  }
  NewProduction() {
    this.Mainmsg = '';
    //this.router.navigate(['/Licenses/CreateNFRLicense']);
  }

  UserData: any;
  IsRMH: boolean = false;
  selectedProductId: any = 0;
  ngOnInit(): void {
    // Initialize Pay Now Form
    this.payNowForm = this.fb.group({
      firstName: ['', Validators.required],
      lastName: ['', Validators.required],
      cardNumber: ['', [Validators.required, Validators.pattern(/^\d{16}$/)]],
      expiryMonth: ['', [Validators.required, Validators.pattern(/^(0[1-9]|1[0-2])$/)]],
      expiryYear: ['', [Validators.required, Validators.pattern(/^\d{2}$/)]],
      cvv: ['', [Validators.required, Validators.pattern(/^\d{3}$/)]],
      addressLine1: [{ value: '', disabled: true }, Validators.required],
      state: [{ value: '', disabled: true }, Validators.required],
      city: [{ value: '', disabled: true }, Validators.required],
      zipCode: [{ value: '', disabled: true }, Validators.required],
      country: [{ value: '', disabled: true }, Validators.required],
    });

    // if (!this.baseService.CheckPermissions('CreateLicenses')) {
    //   this.router.navigate(['/dashboard']);
    // }
    // this.UsersService.selectedClientData.subscribe((data) => {
    //   this.UserData = data;
    //   console.log(
    //     '🚀 > CreatelicenseComponent > ngOnInit > this.UserData',
    //     this.UserData
    //   );
    // });

    // Check localStorage for previously selected product
    const storedProductId = localStorage.getItem('Product_Id');
    if (storedProductId) {
      this.selectedProductId = storedProductId;
    }

    this.route.queryParams.subscribe((params) => {
      const productId = params['Product_Id'];
      if (productId) {
        this.selectedProductId = productId;
        console.log("Product change");
        localStorage.setItem('Product_Id', this.selectedProductId);

      }
    });

    this.Product_Id = localStorage.getItem('Product_Id');


    this.UserData = JSON.parse(
      localStorage.getItem('UserInfo')?.toString() || '{}'
    );

    this.partnerpercentage = JSON.parse(
      localStorage.getItem('packages') || '{}'
    )[0]?.discountPercent;

    this.serviceItemDiscount = JSON.parse(
      localStorage.getItem('packages') || '{}'
    )[0]?.serviceDiscountPercent;

    console.log('Partner Percentage: ' + this.partnerpercentage);
    console.log('Partner Percentage Service: ' + this.serviceItemDiscount);
    this.GetProductList(this.UserData.id);
    this.CheckIfPartner();
  }

  //--------------------------------------------------

  /**
   * Calculates the total price for a package based on a filter function.
   * @param taskList The list of modules with features.
   * @param featureFilter A function that receives a feature and returns true if it should be included in the calculation.
   * @returns The total price (including price and price_OneTime if present) for the filtered features.
   */
  calculatePackageTotal(
    taskList: any[],
    featureFilter: (feature: any) => boolean
  ): number {
    if (!taskList || !Array.isArray(taskList)) return 0;
    let total = 0;
    // Use selectedDuration.chargeDuration if available, otherwise default to 1
    const durationMultiplier =
      this.selectedDuration && this.selectedDuration.chargeDuration
        ? Number(this.selectedDuration.chargeDuration)
        : 1;
    for (const module of taskList) {
      if (module.featureList && Array.isArray(module.featureList)) {
        for (const feature of module.featureList) {
          // Exclude service items from calculation
          if (feature.isServiceItem) continue;
          if (featureFilter(feature)) {
            total += (Number(feature.price) || 0) * durationMultiplier;
            if (feature.price_OneTime) {
              total += Number(feature.price_OneTime) || 0;
            }
          }
        }
      }
    }
    return total;
  }

  getStandardPlanTotal(taskList: any[]): number {
    return this.calculatePackageTotal(
      taskList,
      (feature) => feature.dependencyID === 0
    );
  }

  getExtendedPlanTotal(taskList: any[]): number {
    // Base features (dependencyID === 0) and any feature with selected === true
    return this.calculatePackageTotal(
      taskList,
      (feature) => feature.dependencyID === 0 || feature.selected === true
    );
  }

  buyStandardPlan(): void {
    this.ButtonLoadingStandard = true;
    if (!this.taskList || !Array.isArray(this.taskList)) {
      this.ButtonLoadingStandard = false;
      return;
    }

    // Select all features with dependencyID === 0
    for (const module of this.taskList) {
      if (module.featureList && Array.isArray(module.featureList)) {
        for (const feature of module.featureList) {
          feature.selected = feature.dependencyID === 0;
        }
      }
    }

    // Recalculate price and proceed to buy
    this.calculateTotalPrice();
    this.updateAllTasks();
  }

  buyExtendedPlan(): void {
    this.ButtonLoadingExtended = true;
    if (!this.taskList || !Array.isArray(this.taskList)) {
      this.ButtonLoadingExtended = false;
      return;
    }

    // Select all features with dependencyID === 0 or already selected
    for (const module of this.taskList) {
      if (module.featureList && Array.isArray(module.featureList)) {
        for (const feature of module.featureList) {
          feature.selected =
            feature.dependencyID === 0 || feature.selected === true;
        }
      }
    }

    // Recalculate price and proceed to buy
    this.calculateTotalPrice();
    this.updateAllTasks();
  }

  /**
   * Calculates the additional store price for the Standard Plan.
   * Only considers features with dependencyID === 0.
   */
  getStandardPlanAdditionalStorePrice(taskList: any[]): number {
    if (
      !taskList ||
      !Array.isArray(taskList) ||
      !this.selectedDuration ||
      !this.extraNOS ||
      this.extraNOS <= 0
    )
      return 0;
    let total = 0;
    const durationMultiplier = this.selectedDuration.chargeDuration
      ? Number(this.selectedDuration.chargeDuration)
      : 1;
    for (const module of taskList) {
      if (module.featureList && Array.isArray(module.featureList)) {
        for (const feature of module.featureList) {
          // Exclude service items
          if (feature.isServiceItem) continue;
          if (feature.dependencyID === 0) {
            total +=
              (Number(feature.price_ExtraStore) || 0) *
              this.extraNOS *
              durationMultiplier;
          }
        }
      }
    }
    return total;
  }

  /**
   * Calculates the additional store price for the Extended Plan.
   * Considers features with dependencyID === 0 or selected === true.
   */
  getExtendedPlanAdditionalStorePrice(taskList: any[]): number {
    if (
      !taskList ||
      !Array.isArray(taskList) ||
      !this.selectedDuration ||
      !this.extraNOS ||
      this.extraNOS <= 0
    )
      return 0;
    let total = 0;
    const durationMultiplier = this.selectedDuration.chargeDuration
      ? Number(this.selectedDuration.chargeDuration)
      : 1;
    for (const module of taskList) {
      if (module.featureList && Array.isArray(module.featureList)) {
        for (const feature of module.featureList) {
          // Exclude service items
          if (feature.isServiceItem) continue;
          if (feature.dependencyID === 0 || feature.selected === true) {
            total +=
              (Number(feature.price_ExtraStore) || 0) *
              this.extraNOS *
              durationMultiplier;
          }
        }
      }
    }
    return total;
  }

  ngOnDestroy(): void {
    if (this.licenseSubscription) {
      this.licenseSubscription.unsubscribe();
    }
  }

  //msg: any;
  //UserData: any;
  UserExtraInfo: any;
  ModalVisible: boolean = false;
  customStylesValidated: boolean = false;
  //Loading: boolean = false;
  //ButtonLoading: boolean = false;
  EditMode: boolean = false;
  icons = freeSet;
  pendingPlan: PlanViewModel | null = null; // Store plan selected before modal opens

  validatePhoneNumberInput(event: KeyboardEvent): void {
    const allowedChars = /[0-9\s()+-]/;
    const inputChar = String.fromCharCode(event.charCode);

    if (!allowedChars.test(inputChar)) {
      event.preventDefault();
    }
  }

  toggleModal() {
    if (this.ModalVisible) {
      this.customStylesValidated = false;
      this.EditMode = false;
    }
    this.ModalVisible = !this.ModalVisible;
  }
  /**
   * Checks if the user is a partner and has business info saved
   * Returns true if business info exists, false otherwise
   */
  async checkIfBusinessInfoExists(): Promise<boolean> {
    return new Promise((resolve) => {
      this.UserData = JSON.parse(
        localStorage.getItem('UserInfo')?.toString() || '{}'
      );
      if (this.UserData.userType_Id == 6) {
        var data = { 
            partner_Id: this.UserData.partner_Id,
            user_Id: this.UserData.id
        }

        console.log("🚀  > checkIfBusinessInfoExists > data:", data);
        
        this.UsersService.GetByUserAndPartnerID(data).subscribe({
          next: (res: any) => {
            console.log(
              '🚀 > CreatelicenseComponent > checkIfBusinessInfoExists > res:',
              res
            );
            // this.UserExtraInfo = res.data;
            if (res.data) {
              this.UsersService.BusinessInfoData = res.data; 
              console.log('Business Info Found');
              resolve(true);
            } else {
              console.log('No Business Info Found');
              resolve(false);
            }
          },
          error: (error) => {
            console.error(error);
            resolve(false);
          },
        });
      } else {
        resolve(true); // Not a partner, business info not needed
      }
    });
  }

  CheckIfPartner() {
    this.UserData = JSON.parse(
      localStorage.getItem('UserInfo')?.toString() || '{}'
    );
    // Note: Business info modal is now triggered when user clicks "Choose Plan" button
    // not automatically on page load
  }
  EditBillingInfo: boolean = false;
  onChangeBillingInformation(event: any) {
    if (event.target.checked) {
      this.EditBillingInfo = true;
    } else {
      this.EditBillingInfo = false;
      this.syncBillingInfoWithUserExtraInfo();
    }
  }

  syncBillingInfoWithUserExtraInfo() {
    if (this.UsersService.UserExtraInfoData) {
      // Map UserExtraInfo fields to BusinessInfoData fields
      this.UsersService.BusinessInfoData.legalName = this.UsersService.UserExtraInfoData.companyName || '';
      this.UsersService.BusinessInfoData.streetAddr = this.UsersService.UserExtraInfoData.addr_Street || '';
      this.UsersService.BusinessInfoData.city = this.UsersService.UserExtraInfoData.addr_City || '';
      this.UsersService.BusinessInfoData.state = this.UsersService.UserExtraInfoData.addr_State || '';
      this.UsersService.BusinessInfoData.zipCode = this.UsersService.UserExtraInfoData.addr_ZipCode || '';
      this.UsersService.BusinessInfoData.country = this.UsersService.UserExtraInfoData.addr_Country || '';
      this.UsersService.BusinessInfoData.phoneNo = this.UsersService.UserExtraInfoData.contactPersonPhone || '';
      this.UsersService.BusinessInfoData.emailAddress = this.UserData.userName || '';
    }
  }

  onStreetAddressChange(value: string): void {
    if (!this.EditBillingInfo) {
      this.UsersService.BusinessInfoData.streetAddr = value;
    }
  }

  onCityChange(value: string): void {
    if (!this.EditBillingInfo) {
      this.UsersService.BusinessInfoData.city = value;
    }
  }
  onCompanyNameChange(value: string): void {
    if (!this.EditBillingInfo) {
      this.UsersService.BusinessInfoData.legalName = value;
    }
  }

  onStateChange(value: string): void {
    if (!this.EditBillingInfo) {
      this.UsersService.BusinessInfoData.state = value;
    }
  }

  onZipCodeChange(value: string): void {
    if (!this.EditBillingInfo) {
      this.UsersService.BusinessInfoData.zipCode = value;
    }
  }

  onEmailChange(value: string): void {
    if (!this.EditBillingInfo) {
      this.UsersService.BusinessInfoData.emailAddress = value;
    }
  }

  onPhoneNumberChange(value: string): void {
    if (!this.EditBillingInfo) {
      this.UsersService.BusinessInfoData.phoneNo = value;
    }
  }

  onCountryChange(value: string): void {
    if (!this.EditBillingInfo) {
      this.UsersService.BusinessInfoData.country = value;
    }
  }

  AddUserCall(
    UserDetailsForm: any,
    UserData: any,
    UserExtraInfoData: UserExtraInfoModel
  ) {
    this.ButtonLoading = true;
    this.customStylesValidated = true;
    if (UserDetailsForm.invalid) {
      const options = {
        title: `Error`,
        delay: 3000,
        color: 'danger',
        autohide: true,
        description: 'Please fill all the required fields and remove errors',
        status: false,
      };
      this.ToastService.showToast(options);
      this.ButtonLoading = false;
      return;
    }
    UserExtraInfoData.users_Id = this.UserData.id;
    UserExtraInfoData.partner_Id = this.UserData.partner_Id;
    this.UsersService.BusinessInfoData.user_Id = this.UserData.id;
    this.UsersService.BusinessInfoData.partner_Id = this.UserData.partner_Id;

    this.UsersService.BusinessInfoData.emailAddress = this.UserData.userName;

    var formData1 = new FormData();
    var formDataOutput = '';
    Object.keys(this.UsersService.BusinessInfoData).forEach((key) => {
      const typedKey = key as keyof typeof this.UsersService.BusinessInfoData;
      if (this.UsersService.BusinessInfoData[typedKey] != null) {
        formData1.append(
          key,
          String(this.UsersService.BusinessInfoData[typedKey])
        );
        formDataOutput +=
          '\n' + key + ':' + this.UsersService.BusinessInfoData[typedKey];
        console.log(key, this.UsersService.BusinessInfoData[typedKey]);
      }
    });
    // console.log("Data For Billing Info")
    // console.log(formData1)

    this.UsersService.AddOrUpdateUserBillingInfo(formData1).subscribe(
      (res: any) => {
        console.log('AddOrUpdateUserBillingInfo response:', res);
      }
    );

    this.UsersService.addUserExtraInfo(UserExtraInfoData).subscribe({
      next: (res: any) => {
        console.log(res);
        if (res.isSuccess) {
          this.UsersService.UserExtraInfoData = new UserExtraInfoModel();
          this.customStylesValidated = false;
          this.ButtonLoading = false;
          this.toggleModal();
          const options = {
            title: `Success`,
            delay: 3000,
            color: 'success',
            autohide: true,
            description: 'Business Information Added Successfully',
            status: true,
          };
          this.ToastService.showToast(options);

          // If a plan was pending (waiting for business info), now proceed with it
          if (this.pendingPlan) {
            const planToApply = this.pendingPlan;
            this.pendingPlan = null; // Clear the pending plan
            // Use setTimeout to allow modal to close and UI to update
            setTimeout(() => {
              this.applyPlanSelection(planToApply);
            }, 500);
          }
        } else {
          const options = {
            title: `Error`,
            delay: 3000,
            color: 'danger',
            autohide: true,
            description: res.apiStatus.message,
            status: false,
          };
          this.ToastService.showToast(options);
          this.ButtonLoading = false;
        }
      },
      error: (error) => {
        console.error(error);
      },
    });
  }

  // logout() {
  //   localStorage.clear();
  //   this.router.navigate(['/login']);
  // }

  /**
   * Calculates the undiscounted (real) price for a package by multiplying the per-period price by the duration.
   * Used for showing the crossed-out price if duration !== chargeDuration.
   */
  calculatePackageRealTotal(
    taskList: any[],
    featureFilter: (feature: any) => boolean
  ): number {
    if (!taskList || !Array.isArray(taskList) || !this.selectedDuration)
      return 0;
    let total = 0;
    const durationMultiplier =
      this.selectedDuration && this.selectedDuration.duration
        ? Number(this.selectedDuration.duration)
        : 1;
    for (const module of taskList) {
      if (module.featureList && Array.isArray(module.featureList)) {
        for (const feature of module.featureList) {
          // Exclude service items from calculation
          if (feature.isServiceItem) continue;
          if (featureFilter(feature)) {
            total += (Number(feature.price) || 0) * durationMultiplier;
            if (feature.price_OneTime) {
              total += Number(feature.price_OneTime) || 0;
            }
          }
        }
      }
    }
    return total;
  }

  getStandardPlanRealTotal(taskList: any[]): number {
    return this.calculatePackageRealTotal(
      taskList,
      (feature) => feature.dependencyID === 0
    );
  }

  getExtendedPlanRealTotal(taskList: any[]): number {
    return this.calculatePackageRealTotal(
      taskList,
      (feature) => feature.dependencyID === 0 || feature.selected === true
    );
  }

  goToPortal() {
    const Product_Id = localStorage.getItem('Product_Id') as string;

    console.log("🚀 > goToPortal > Product_Id:", Product_Id)

    if (Product_Id === '12' || Product_Id === '11') {
      this.baseService.getIntuitConnectURL(Product_Id).subscribe({
        next: (response) => {
          localStorage.clear();
          window.location.href = response?.APIStatus?.Details; // Assuming response has 'url' property
        },
        error: (err) => {
          console.error('Error getting connect URL:', err);
          // Optionally show a toast or handle error
        }
      });
    }
  }

  CancelPlanPurchase() {
    this.resetPlanLoadingState();
    this.togglePayNowModal();
    this.selectedPlanId = null;
  }

}
